import script from "./ViewSubSectorsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSubSectorsPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewSubSectorsPage.vue?vue&type=style&index=0&id=c86e77ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c86e77ea"]])

export default __exports__